import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import React from 'react'
import PersonalInformation from './PersonalInformation'
import Achievements from './Achievements'
import Summary from './Summary'
import Certifications from './Certifications'
import Education from './Education'
import WorkExperience from './WorkExperience/WorkExperience'

const DetailedViewTab = ({ genAIJson }) => {
    console.log(genAIJson)
    return (
        <Tabs>
            <TabList>
                <Tab>Personal Information</Tab>
                <Tab>Achievements</Tab>
                <Tab>Summary</Tab>
                <Tab>Education</Tab>
                <Tab>Certifications</Tab>
                <Tab>Work Experience</Tab>
            </TabList>

            <TabPanels>
                <TabPanel>
                    <PersonalInformation PersonalInformation={genAIJson.PersonalInformation} />
                </TabPanel>
                <TabPanel>
                    <Achievements Achievements={genAIJson.Achievements} />
                </TabPanel>
                <TabPanel>
                    <Summary Summary={genAIJson.Summary} />
                </TabPanel>
                <TabPanel>
                    <Education Education={genAIJson.Education} />
                </TabPanel>
                <TabPanel>
                    <Certifications Certifications={genAIJson.Certifications} />
                </TabPanel>
                <TabPanel>
                    <WorkExperience WorkExperience={genAIJson.WorkExperience} />
                </TabPanel>
            </TabPanels>
        </Tabs>
    )
}

export default DetailedViewTab